function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M164.898 395.01H31.1849V415.323H164.898V395.01Z",
  fill: "#1D386B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.93 415L16 833H25.3291L46 415.397L30.93 415Z",
  fill: "#EEEEEE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M165.079 415L180 833H170.683L150 415.397L165.079 415Z",
  fill: "#EEEEEE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59.6406 415.397L43 833H54.6338L70 415L59.6406 415.397Z",
  fill: "#E0E0E0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M138.958 415.397L155 833H143.78L129 415L138.958 415.397Z",
  fill: "#E0E0E0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M143 771H57V780H143V771Z",
  fill: "#E0E0E0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M143 722H57V730H143V722Z",
  fill: "#E0E0E0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M143 675H60V684H143V675Z",
  fill: "#E0E0E0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M140 628H60V634H140V628Z",
  fill: "#E0E0E0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M133 578H62V588H133V578Z",
  fill: "#E0E0E0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M136 531H62V539H136V531Z",
  fill: "#E0E0E0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M136.066 496.052H62.3698V507.388H136.066V496.052Z",
  fill: "#E0E0E0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M133.242 438.37H66.1458V449.706H133.242V438.37Z",
  fill: "#E0E0E0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M196.534 356.208H0V397.793H196.534V356.208Z",
  fill: "#1D386B"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M186.153 63.7603L117.797 108.29C117.128 105.535 115.569 103.078 113.362 101.3C114.163 99.1541 114.292 96.8154 113.734 94.594C113.632 93.9545 113.383 93.3473 113.007 92.8199C112.654 92.4886 112.225 92.2478 111.759 92.118C111.292 91.9882 110.801 91.9734 110.328 92.0748L99.4705 92.7844C98.2062 92.7236 96.9578 93.0856 95.9223 93.8134C94.3966 95.0907 93.9353 97.7696 92.3741 98.905C91.3274 99.6501 89.9968 99.5792 88.8259 100.165C86.3244 101.495 85.7745 105.487 85.5793 108.733C85.3132 113.169 85.331 118.385 88.2227 121.152C90.3339 123.121 93.2611 122.926 95.9223 122.784L98.6011 122.571C99.2782 122.973 99.9909 123.312 100.73 123.583V127.361H100.233C100.233 127.361 69.5948 118.491 35.9403 211.169H35.3548C35.3548 211.169 30.3873 228.023 38.3353 225.061C45.2542 222.47 45.4316 213.831 45.3075 211.666H45.7687C45.7687 211.666 59.6599 171.004 81.4812 166.037C81.4812 166.037 97.3593 185.871 71.564 225.54H91.7531C91.6893 229.978 92.585 234.377 94.3788 238.437C100.322 250.341 82.4747 363.404 82.4747 363.404H97.3593L104.846 325.935L105.786 363.404H116.697L127.608 291.358L126.117 204.57V182.092L128.104 184.736V150.017H156.862L161.83 111.341H161.315C161.437 108.64 161.324 105.933 160.978 103.252L198.057 95.4633C203.893 70.6792 186.153 63.7603 186.153 63.7603ZM153.687 111.945L144.994 134.174C144.994 134.174 121.185 123.263 112.262 127.237H111.765V122.518C113.59 121.463 115.128 119.977 116.245 118.189C117.362 116.401 118.022 114.367 118.169 112.264L153.917 104.759C153.455 107.12 153.371 109.54 153.669 111.927L153.687 111.945Z",
  fill: "url(#paint0_linear)"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M159.112 117.693C159.112 117.693 160.248 101.301 155.138 104.902C150.029 108.504 152.229 118.705 152.229 118.705L159.112 117.693Z",
  fill: "#FDA57D"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2157 211.156C39.2157 211.156 34.4966 227.212 42.0542 224.391C49.6119 221.57 48.6716 211.156 48.6716 211.156H39.2157Z",
  fill: "#FDA57D"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M111.991 125.218H101.595V134.674H111.991V125.218Z",
  fill: "#FDA57D"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M101.564 177.172H93.0664V219.697H101.564V177.172Z",
  fill: "#1D386B"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M101.564 177.172H93.0664V219.697H101.564V177.172Z",
  fill: "black"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M105.638 131.338H115.466C118.172 131.338 120.766 132.413 122.68 134.326C124.593 136.239 125.667 138.834 125.667 141.539V205.034H95.5078V141.539C95.5077 138.846 96.5727 136.262 98.4705 134.351C100.368 132.44 102.945 131.357 105.638 131.338Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M105.831 128.418C112.612 128.418 118.108 122.921 118.108 116.141C118.108 109.361 112.612 103.865 105.831 103.865C99.0512 103.865 93.5547 109.361 93.5547 116.141C93.5547 122.921 99.0512 128.418 105.831 128.418Z",
  fill: "#FDA57D"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M101.1 131.297C101.1 131.297 71.8098 122.799 39.681 211.61H49.1369C49.1369 211.61 62.3716 172.864 83.1462 168.145C83.1462 168.145 98.2615 187.039 73.6903 224.916H93.5424V212.249C93.4267 193.05 95.8122 173.919 100.639 155.336C102.915 147.505 103.074 139.21 101.1 131.297V131.297Z",
  fill: "#D4182A"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M112.435 131.349V134.188C112.435 134.188 119.052 163.478 124.712 182.372L127.603 186.222V153.082H155.013L159.732 116.234H152.175L143.57 137.949C143.57 137.949 120.933 127.553 112.435 131.349Z",
  fill: "#D4182A"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M95.4185 204.977C95.4185 204.977 89.7414 225.769 95.4185 237.106C101.096 248.442 84.082 356.165 84.082 356.165H98.2748L118.588 254.581L121.888 204.906L95.4185 204.977Z",
  fill: "#333333"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M125.691 205.036L127.11 287.709L116.714 356.224H106.318L102.539 205.036H125.691Z",
  fill: "#333333"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M103.813 111.504C104.065 111.094 104.376 110.724 104.736 110.404C105.091 110.196 105.495 110.086 105.907 110.085C108.479 109.872 111.442 109.819 113.003 107.388C114.15 105.206 114.429 102.671 113.784 100.292C113.699 99.6535 113.462 99.0448 113.092 98.5179C112.755 98.2019 112.347 97.9723 111.902 97.8487C111.457 97.7251 110.988 97.7112 110.537 97.8083L100.194 98.4824C99.0113 98.4374 97.8463 98.78 96.8764 99.4582C95.4217 100.682 94.9959 103.219 93.4702 104.319C92.4589 105.029 91.1994 104.958 90.1349 105.526C87.7576 106.785 87.2431 110.546 87.048 113.686C86.7996 117.909 86.7996 122.876 89.5672 125.449C91.5719 127.329 94.3572 127.223 96.8942 127.01L101.613 126.62C102.089 126.632 102.557 126.489 102.944 126.211C103.242 125.812 103.454 125.355 103.564 124.869C103.674 124.383 103.68 123.879 103.583 123.391C103.458 121.013 103.21 118.317 101.649 116.862C101.276 116.582 100.937 116.261 100.638 115.904C98.9521 113.278 102.926 112.675 103.813 111.504Z",
  fill: "#333333"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M182.841 70.9215C182.841 70.9215 199.855 77.5389 194.178 101.081L117.643 117.137V113.358L182.841 70.9215Z",
  fill: "#D4182A"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M164.875 397.354H31.6406V401.133H164.875V397.354Z",
  fill: "black"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M64 621H53V623H64V621Z",
  fill: "black"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M145 621H135V623H145V621Z",
  fill: "black"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M164 608H31V622H164V608Z",
  fill: "#EEEEEE"
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 255,
  cy: 89,
  r: 15,
  fill: "#D4182A"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 385,
  cy: 97,
  r: 15,
  fill: "#D4182A"
});

var _ref36 = /*#__PURE__*/React.createElement("circle", {
  cx: 452,
  cy: 20,
  r: 20,
  fill: "#D4182A"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  cx: 475.5,
  cy: 203.5,
  r: 16.5,
  fill: "#D4182A"
});

var _ref38 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 568,
  cy: 38.5,
  rx: 18,
  ry: 17.5,
  fill: "#D4182A"
});

var _ref39 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 610,
  cy: 195.5,
  rx: 22,
  ry: 21.5,
  fill: "#D4182A"
});

var _ref40 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 714.5,
  cy: 54,
  rx: 31.5,
  ry: 32,
  fill: "#D4182A"
});

var _ref41 = /*#__PURE__*/React.createElement("circle", {
  cx: 759.5,
  cy: 161.5,
  r: 36.5,
  fill: "#D4182A"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  cx: 547,
  cy: 230,
  r: 20,
  fill: "#D4182A"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 566.5,
  cy: 141.5,
  r: 19.5,
  fill: "#D4182A"
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  cx: 706.5,
  cy: 352.5,
  r: 25.5,
  fill: "#D4182A"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 745,
  cy: 268.5,
  rx: 19,
  ry: 18.5,
  fill: "#D4182A"
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  cx: 880.5,
  cy: 134.5,
  r: 25.5,
  fill: "#D4182A"
});

var _ref47 = /*#__PURE__*/React.createElement("circle", {
  cx: 887.5,
  cy: 281.5,
  r: 19.5,
  fill: "#D4182A"
});

var _ref48 = /*#__PURE__*/React.createElement("circle", {
  cx: 1033,
  cy: 84,
  r: 15,
  fill: "#D4182A"
});

var _ref49 = /*#__PURE__*/React.createElement("circle", {
  cx: 992.5,
  cy: 221.5,
  r: 24.5,
  fill: "#D4182A"
});

var _ref50 = /*#__PURE__*/React.createElement("circle", {
  cx: 875.5,
  cy: 42.5,
  r: 20.5,
  fill: "#D4182A"
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 317,
  cy: 139.5,
  rx: 17,
  ry: 17.5,
  fill: "#1D386B"
});

var _ref52 = /*#__PURE__*/React.createElement("circle", {
  cx: 311.5,
  cy: 53.5,
  r: 22.5,
  fill: "#1D386B"
});

var _ref53 = /*#__PURE__*/React.createElement("circle", {
  cx: 458.5,
  cy: 71.5,
  r: 21.5,
  fill: "#1D386B"
});

var _ref54 = /*#__PURE__*/React.createElement("circle", {
  cx: 430.5,
  cy: 149.5,
  r: 19.5,
  fill: "#1D386B"
});

var _ref55 = /*#__PURE__*/React.createElement("circle", {
  cx: 502.5,
  cy: 130.5,
  r: 21.5,
  fill: "#1D386B"
});

var _ref56 = /*#__PURE__*/React.createElement("circle", {
  cx: 633,
  cy: 98,
  r: 28,
  fill: "#1D386B"
});

var _ref57 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 687,
  cy: 165.5,
  rx: 19,
  ry: 19.5,
  fill: "#1D386B"
});

var _ref58 = /*#__PURE__*/React.createElement("circle", {
  cx: 803.5,
  cy: 93.5,
  r: 21.5,
  fill: "#1D386B"
});

var _ref59 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 831.5,
  cy: 216,
  rx: 20.5,
  ry: 20,
  fill: "#1D386B"
});

var _ref60 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 653,
  cy: 272.5,
  rx: 27,
  ry: 26.5,
  fill: "#1D386B"
});

var _ref61 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 570,
  cy: 289.5,
  rx: 20,
  ry: 20.5,
  fill: "#1D386B"
});

var _ref62 = /*#__PURE__*/React.createElement("circle", {
  cx: 767,
  cy: 407,
  r: 31,
  fill: "#1D386B"
});

var _ref63 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 802.5,
  cy: 320,
  rx: 20.5,
  ry: 21,
  fill: "#1D386B"
});

var _ref64 = /*#__PURE__*/React.createElement("circle", {
  cx: 926,
  cy: 189,
  r: 15,
  fill: "#1D386B"
});

var _ref65 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 951.5,
  cy: 339,
  rx: 27.5,
  ry: 28,
  fill: "#1D386B"
});

var _ref66 = /*#__PURE__*/React.createElement("circle", {
  cx: 1070.5,
  cy: 169.5,
  r: 27.5,
  fill: "#1D386B"
});

var _ref67 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1060.5,
  cy: 289,
  rx: 34.5,
  ry: 34,
  fill: "#1D386B"
});

var _ref68 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 968,
  cy: 99.5,
  rx: 27,
  ry: 27.5,
  fill: "#1D386B"
});

var _ref69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 116.537,
  y1: 363.262,
  x2: 116.537,
  y2: 63.7248,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})));

var SvgNews = function SvgNews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1098,
    height: 833,
    viewBox: "0 0 1098 833",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/news.ee1c9080.svg";
export { ForwardRef as ReactComponent };